import { render, staticRenderFns } from "./IconListDefaultLayout.vue?vue&type=template&id=08c546a2&scoped=true&"
import script from "./IconListDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./IconListDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c546a2",
  null
  
)

export default component.exports